export default "__VITE_ASSET__CVW3NNkE__"